import cn from "classnames";
import "./index.css";
import BgTransformer from "../../../layout/BgTransformer";
import PixelationLayer from "../../../layout/PixelationLayer";
import Textarea from "../../../layout/Textarea/Textarea";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {type DemoVideoTexts, DemoVideoIcon} from "./parts";

/**
 * Intro (Figma "release/intro/light" 12710:1402 and "…/dark" 12710:1413):
 * the product icon, the headline and the subtitle on the product background.
 * Light and dark are two backgrounds of one banner.
 */
const DemoVideoIntro = ({id, zoom}: {id: string; zoom: number}) => {
  const {product} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles}: DemoVideoTexts<"titles" | "subtitles"> = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  return (
    <div
      id={id}
      className={cn("template", product.value, "demo-video", "demo-video-intro")}
      style={{"--zoom-level": zoom} as React.CSSProperties}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <DemoVideoIcon />
          <div className="dv-text">
            <h1 className="title">
              <Textarea id={id} text={title} />
            </h1>
            <h2 className="subtitle">
              <Textarea id={id} text={subtitle} />
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoVideoIntro;
